export default __webpack_public_path__ + "static/media/logo singa ke bawah.e07882f8.png";